// components/Piac/MobileDrawer.jsx
import React, { useState } from 'react';
import { SwipeableDrawer, Button, Box, Typography, Checkbox, FormControlLabel, Switch, IconButton, Grid} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

import { useTranslation } from 'react-i18next';
import { CategoryLabels as getCategoryLabels, KeyLabels as getKeyLabels, CategoryTooltips, AdmLabels as getAdmLabels, categories, admlayers, } from '../../Constants/IngatlanOptions.js';

import CardComponent from "./PiacComponents/CardComponent";
const MobileDrawer = ({
                          allListings,
                          selectedCategories,
                          selectedKeys,
                          selectedAdmLayers,
                          showCsango,
                          setShowCsango,
                          handleCategoryToggle,
                          handleKeyToggle,
                          handleAdmLayerToggle,
                          state,
                          setFlyToLocation,
                          navigate
                      }) => {
    const { t } = useTranslation();
    const CategoryLabels = getCategoryLabels(t);
    const KeyLabels = getKeyLabels(t);
    const AdmLabels = getAdmLabels(t);
    const [filterOpen, setFilterOpen] = useState(false);
    const [cardsOpen, setCardsOpen] = useState(false);

    return (
        <>
            <Box sx={{
                position: 'absolute',
                bottom: 80,
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1100,
                display: 'flex',
                gap: 1,
                width: '100%',
                px: 2,
                justifyContent: 'center',
                pointerEvents: 'none' // Csak a gombok legyenek kattinthatóak
            }}>
                <Button
                    variant="contained"
                    className="mobile-menu-button-new"
                    onClick={() => setFilterOpen(true)}
                    sx={{ 
                        pointerEvents: 'auto',
                        flex: 1,
                        maxWidth: '160px'
                    }}
                >
                    {t('Map.Layers')}
                </Button>
                <Button
                    variant="contained"
                    className="mobile-menu-button-new"
                    onClick={() => setCardsOpen(true)}
                    sx={{ 
                        pointerEvents: 'auto',
                        flex: 1,
                        maxWidth: '160px'
                    }}
                >
                    {t('Map.ForSale')}
                </Button>
            </Box>

            {/* Filter Drawer */}
            <SwipeableDrawer
                anchor="left"
                open={filterOpen}
                onClose={() => setFilterOpen(false)}
                onOpen={() => setFilterOpen(true)}
                disableBackdropTransition={true}
                disableDiscovery={true}
                PaperProps={{
                    sx: { width: '85%', maxWidth: '360px' }
                }}
            >
                <Box className="drawer-content">
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography variant="h6" sx={{ mb: 0 }}>{t('Map.Categories')}</Typography>
                        <IconButton onClick={() => setFilterOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    {Object.entries(categories).map(([category, keys]) => (
                        <Box key={category} sx={{ mb: 3, p: 2, bgcolor: 'rgba(0,0,0,0.03)', borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'var(--sznodarkblue)' }}>
                                    {CategoryLabels[category]}
                                </Typography>
                                <Switch
                                    size="small"
                                    checked={selectedCategories.includes(category)}
                                    onChange={() => handleCategoryToggle(category)}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', ml: 1 }}>
                                {keys.map(key => (
                                    <FormControlLabel
                                        key={key}
                                        control={
                                            <Checkbox
                                                size="small"
                                                checked={selectedKeys[category][key]}
                                                onChange={() => handleKeyToggle(category)(key)}
                                                disabled={!selectedCategories.includes(category)}
                                            />
                                        }
                                        label={<Typography variant="body2">{KeyLabels[key]}</Typography>}
                                    />
                                ))}
                                {category === 'Epitettorokseg' && (
                                    <>
                                        <Typography variant="overline" sx={{ mt: 2, display: 'block', fontWeight: 'bold', color: 'grey.600' }}>
                                            {t('Map.Layers')}
                                        </Typography>
                                        {['kapolna', 'templom', 'var', 'kastely', 'udvarhaz'].map(subKey => (
                                            <FormControlLabel
                                                key={subKey}
                                                control={
                                                    <Checkbox
                                                        size="small"
                                                        checked={selectedKeys[category][subKey]}
                                                        onChange={() => handleKeyToggle(category)(subKey)}
                                                        disabled={!selectedCategories.includes(category)}
                                                    />
                                                }
                                                label={<Typography variant="body2">{KeyLabels[subKey]}</Typography>}
                                            />
                                        ))}
                                    </>
                                )}
                            </Box>
                        </Box>
                    ))}

                    <Typography variant="h6" sx={{ mt: 2, mb: 1, px: 1 }}>{t('Map.Administration')}</Typography>
                    <Box sx={{ mb: 3, p: 2, bgcolor: 'rgba(0,0,0,0.03)', borderRadius: 2 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                            <Typography variant="body2">{t('Map.Toolbox.csango_gis', 'Csángó GIS')}</Typography>
                            <Checkbox 
                                size="small"
                                checked={showCsango} 
                                onChange={(e) => setShowCsango(e.target.checked)} 
                            />
                        </Box>
                        {['megye', 'szek', 'kozsegvaros', 'telepules'].map(admlayer => (
                            <Box key={admlayer} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="body2">{AdmLabels[admlayer]}</Typography>
                                <Switch
                                    size="small"
                                    checked={selectedAdmLayers.includes(admlayer)}
                                    onChange={() => handleAdmLayerToggle(admlayer)}
                                />
                            </Box>
                        ))}
                    </Box>

                    <Typography variant="h6" sx={{ mt: 2, mb: 1, px: 1 }}>{t('Map.Geography')}</Typography>
                    <Box sx={{ mb: 3, p: 2, bgcolor: 'rgba(0,0,0,0.03)', borderRadius: 2 }}>
                        {['helynev', 'folyovizek'].map(admlayer => (
                            <Box key={admlayer} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography variant="body2">{AdmLabels[admlayer]}</Typography>
                                <Switch
                                    size="small"
                                    checked={selectedAdmLayers.includes(admlayer)}
                                    onChange={() => handleAdmLayerToggle(admlayer)}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            </SwipeableDrawer>

            {/* Cards Drawer */}
            <SwipeableDrawer
                anchor="bottom"
                open={cardsOpen}
                onClose={() => setCardsOpen(false)}
                onOpen={() => setCardsOpen(true)}
                disableBackdropTransition={true}
                disableDiscovery={true}
                PaperProps={{
                    sx: { 
                        height: '70vh', 
                        borderTopLeftRadius: 20, 
                        borderTopRightRadius: 20,
                        overflow: 'hidden'
                    }
                }}
            >
                <Box sx={{ width: 40, height: 4, bgcolor: 'grey.300', borderRadius: 2, mx: 'auto', mt: 1.5, mb: 1 }} />
                <Box className="drawer-content" sx={{ pt: 0 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, position: 'sticky', top: 0, bgcolor: '#fcfcfc', zIndex: 1, pt: 1 }}>
                        <Typography variant="h6" sx={{ mb: 0, borderBottom: 'none' }}>{t('Map.Listings')}</Typography>
                        <IconButton onClick={() => setCardsOpen(false)} size="small">
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Box className="drawer-cards-grid">
                        <Box className="section-header" sx={{ mt: 1 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{t('Map.Properties')}</Typography>
                            <Button size="small" variant="outlined" onClick={() => navigate('/all-property-listings')} sx={{ textTransform: 'none' }}>{t('Map.All')}</Button>
                        </Box>
                        {allListings.filter(l => l.key === 'Ingatlan').map(listing => (
                            <CardComponent
                                key={listing.id}
                                listing={listing}
                                state={state}
                                setFlyToLocation={setFlyToLocation}
                                navigate={navigate}
                            />
                        ))}

                        <Box className="section-header" sx={{ mt: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>{t('Map.Cars')}</Typography>
                            <Button size="small" variant="outlined" onClick={() => navigate('/all-car-listings')} sx={{ textTransform: 'none' }}>{t('Map.All')}</Button>
                        </Box>
                        {allListings.filter(l => l.key === 'Auto').map(listing => (
                            <CardComponent
                                key={listing.id}
                                listing={listing}
                                state={state}
                                setFlyToLocation={setFlyToLocation}
                                navigate={navigate}
                            />
                        ))}

                        {allListings.filter(l => l.key !== 'Ingatlan' && l.key !== 'Auto').map(listing => (
                            <CardComponent
                                key={listing.id}
                                listing={listing}
                                state={state}
                                setFlyToLocation={setFlyToLocation}
                                navigate={navigate}
                            />
                        ))}
                    </Box>
                </Box>
            </SwipeableDrawer>
        </>
    );
};

export default MobileDrawer;
